// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CommercialAgreement } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/CommercialAgreement';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useLedgerEnd } from '../ledger/useLedgerEnd';

export const useCommercialAgreements: () => UseQueryResult<
  TemplateContract<CommercialAgreement>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['queryCommercialAgreements', ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryCommercialAgreements(offset!, operator);
    },
    enabled: !!offset,
  });
};
